import React, { useState } from 'react'
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { Row, Col, Alert } from 'react-bootstrap';
import { isEmailAddressValid } from "../../util/Validators";
import { API } from 'api/API';
import { extractError } from '../../api/ErrorUtil';
import { FORGOT_PASSWORD } from 'config/config';

const ForgotPasswordPage = () => {

  let [email, setEmail] = useState("");
  let [validationError, setValidationError] = useState("");
  let [valid, setValid] = useState(true);
  let [submitSuccess, setSubmitSuccess] = useState(false);
  let [submitMessage, setSubmitMessage] = useState("");
  let [errors, setErrors]=useState({});


  const handleChange = (event) => {
    setEmail(event.target.value);
  }

  const handleValidation = (event) => {
    if (!isEmailAddressValid(event.target.value)) {
      setValidationError("Enter a valid email address");
      setValid(false);
      return;
    }
    setValidationError("");
    setValid(true);

  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!valid) {
      alert("Form has validation errors");
      return false;
    }
    try {
      let forgotPasswdResp = await API.put(FORGOT_PASSWORD, { email: email })
      setSubmitSuccess(true);
      setSubmitMessage("Check your email and login with the temporary password. You will be required to change the temporary password on login");
    } catch (er) {
      let error = extractError(er);
      setErrors(error.errors);
      setSubmitSuccess(false);
      setSubmitMessage("Error when resetting the password");

    }
  }
  return (
    <>
      {submitMessage && <Alert>{submitMessage}</Alert>}
      <FormContainer title="Enter Email Address" submitButtonFunction={handleSubmit} errors={errors}>
        Enter an Email address associated with your account and then click the button "Sent Temporary Password". A temporary password will be sent in email. When you login using 
        this password you will be asked to change the temporary password.
        <Row><Col className="pe-1" md="8">
          <FormField name="email" label="Email Address" type="text" value={email}
            placeholder="Enter email address" onChange={handleChange} onBlur={handleValidation}
            valstate={valid} valMsg={validationError} />
        </Col></Row>
        <Row>
          <Col> &nbsp;</Col>
        </Row>
        <SubmitButton label='Send Temporary Password' />
      </FormContainer>
    </>
  )
}

export default ForgotPasswordPage